import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { HeroDesktopProps } from '../types';
import {
  sendAmplitudeAnalyticEvent,
  AmplitudeEvents,
  sendRudderStackAnalyticEvent,
} from '@utils/analytics';
import {
  AnalyticsProductType,
  ClickCtaType,
  ClickCtaUxSource,
} from 'src/types/analytics';
import { useAppSelector } from '@store/hook';
import { getBaseAppType } from '@store/shell-state/shellState';
import { BaseAppType } from 'src/types';

const Desktop = (props: HeroDesktopProps) => {
  const { CTAText, CTAUrl, subInfo } = props;
  const baseAppType = useAppSelector(getBaseAppType);

  const handleOnClick = () => {
    sendAmplitudeAnalyticEvent(AmplitudeEvents.clickSignUp, {
      btnPosition: 'Workflow Card',
    });
    sendRudderStackAnalyticEvent({
      event_name: 'click_cta',
      event_properties: {
        ux_source: ClickCtaUxSource.WorkflowCard,
        type: ClickCtaType.ClickSignup,
        feature_utm: 'na',
        product:
          baseAppType === BaseAppType.AI
            ? AnalyticsProductType.AI
            : AnalyticsProductType.STUDIO,
      },
    });
    if (!CTAUrl) {
      const url = new URL(
        window.location.pathname + 'editor',
        process.env.NEXT_PUBLIC_TOOLS_HOST,
      );
      window.open(url.toString(), '_self');
    } else {
      window.open(CTAUrl || '/workflow/marketing-templates', '_self');
    }
  };

  return (
    <div className={ivclass('iv-inline-block')}>
      <div className={ivclass('iv-p-5')}>
        <button
          className={ivclass(
            'iv-flex',
            'iv-items-center',
            'iv-h-65',
            'iv-px-40',
            'iv-rounded-full',
            'iv-bg-blue hover:iv-bg-blue-strong iv-text-grey-0',
            'md:iv-text-body-3xl lg:iv-text-body-3xl xl:iv-text-body-3xl',
            'md:iv-m-body-3xl lg:iv-m-body-3xl xl:iv-m-body-3xl',
            'iv-font-bold',
          )}
          type="button"
          onClick={handleOnClick}
        >
          {CTAText}
        </button>
      </div>
      <div
        className={ivclass(
          'iv-pt-15',
          'iv-text-center iv-text-body-m',
          'iv-text-black-50',
          'iv-font-medium',
        )}
      >
        {subInfo}
      </div>
    </div>
  );
};

export default Desktop;
